import store from "../../store/index.js";
const prefsKey = "prefs";

export default async function loadSettings(to, from, next) {
	const settingsLoaded = store.getters["settings/getLoaded"];

	if (settingsLoaded) {
		next();
	} else {
		const storedPrefs = sessionStorage.getItem(prefsKey);
		let prefsValue = store.getters["settings/getPrefs"];

		if (!storedPrefs) {
			sessionStorage.setItem(prefsKey, JSON.stringify(prefsValue));
		} else {
			prefsValue = JSON.parse(storedPrefs);
			store.commit("settings/setPrefs", prefsValue);
		}

		store.dispatch("settings/loadSettings", {code: prefsValue.country_code}).finally(() => {
			next();
		});
	}
}
